<template lang="html">
  <div v-if="active && showMessage && (items.length === 0)"
    class="empty text-primary text-center mt-3">
    {{ message || 'No se encontraron publicaciones' }}
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    active: Boolean,
    message: String | null
  },
  data () {
    return {
      showMessage: false
    };
  },
  watch: {
    active (newValue) {
      if (newValue) {
        setTimeout (() => {
          this.showMessage = true;
        }, 300);
      } else {
        this.showMessage = false;
      }
    }
  }
}
</script>

<style lang="scss">
  .empty {
    font-size: 1.125rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/EmptyResultsMessage.vue